import React from 'react';
import { Box, Divider, ToggleButton, ToggleButtonGroup } from '@mui/material';

// `right` is optional content aligned to the right end of the tab row.
function PillTabs({ value, onChange, tabs, right }) {
    return (
        <>
            <Box
                sx={{
                    px: 2,
                    py: 1.5,
                    flexShrink: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                <ToggleButtonGroup
                    value={value}
                    exclusive
                    onChange={(_, v) => v && onChange(v)}
                    size='small'
                    sx={{
                        bgcolor: 'action.hover',
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                        p: 0.5,
                        gap: 0.5,
                        overflow: 'visible',
                        '& .MuiToggleButtonGroup-grouped': {
                            border: 'none !important',
                            borderRadius: '8px !important',
                        },
                        '& .MuiToggleButtonGroup-grouped.Mui-selected': {
                            border: '1px solid rgba(0,0,0,0.1) !important',
                        },
                    }}>
                    {tabs.map(({ value: v, label }) => (
                        <ToggleButton
                            key={v}
                            value={v}
                            disableRipple
                            sx={{
                                px: 2,
                                textTransform: 'none',
                                fontSize: 13,
                                fontWeight: 500,
                                color: 'text.secondary',
                                '&.Mui-selected': {
                                    bgcolor: 'background.paper',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                    color: 'text.primary',
                                },
                                '&.Mui-selected:hover': { bgcolor: 'background.paper' },
                            }}>
                            {label}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
                {right}
            </Box>
            <Divider />
        </>
    );
}

export { PillTabs };
